// extracted by mini-css-extract-plugin
export default {"zrpWidgetContainer":"_3BAYl","noResultCarouselContainer":"Rb1nN","tabsTitle":"AKKl4"};